import { Divider, Drawer, Space, Checkbox, Select, Tooltip, Spin, Slider } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import PositionAlign from "../../UI/PositionAlign";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import Carousel from "../../UI/Carousel";
import Images from "../../UI/Images";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_ic_align, tt_ic_animate, tt_ic_display, tt_ic_padding_x, tt_ic_padding_y, tt_ic_width, tt_name_block_warning } from "../../../utils/Utils";
import MobileSelector from "../../UI/MobileSelector";
import PresetPicker from "../../../globals/styles/PresetPicker";
import SliderInput from "../../UI/SiderInput";

export default function ImageCarousel(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0, view = "desktop", setView = () => { } } = props;
    const [template,] = useTemplate();
    const [content, setContent] = useState(props.content);
    const [mobile, setMobile] = useState(false)

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = false,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        animation = "fade",
        height = 500,
        width = 0,
        padding_y = 0,
        padding_x = 0,
        background_colour = 0,
        button_type = 1,
        bg_horizontal_align = "center",
        bg_vertical_align = "center",
        background_size = "cover",
        align = "center",
        images = [],
        auto = false,
        timeout = 3,
        image_radius = 0,
        content_header_style = 0,
        content_paragraph_style = 0,
        content_button_style = 0,
        content_padding_x = 10,
        content_padding_y = 10,
        content_align = "center",
        content_justify = "center", // "start, center, end"
        content_text_align = "center", //"left, center right"
        image_opacity = 100,
        contained = false,
        content_max_width = 1248,

        allow_mobile_overrides = false,
        mobile_height = 500,
        mobile_width = 0,
        mobile_padding_y = 0,
        mobile_padding_x = 0,
        mobile_bg_horizontal_align = "center",
        mobile_bg_vertical_align = "center",
        mobile_background_size = "cover",
        mobile_align = "center",

        mobile_content_header_style = 0,


    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {
        let _align;
        switch (align) {
            case "center":
                _align = "0 auto"
                break;
            case "right":
                _align = "0 0 0 auto"
                break
            default:
                _align = "0 0 0 0"
        }

        let carouselStyle = {
            background: getColor(background_colour, template),
            backgroundPositionX: bg_horizontal_align,
            backgroundPositionY: bg_vertical_align,
            padding: `${padding_y}px ${padding_x}px`,
            position: "relative",
            maxWidth: (width) ? width + "px" : "100%",
            margin: _align,
        };

        let background_position = bg_horizontal_align + " " + bg_vertical_align;

        // mobile

        const m = (allow_mobile_overrides && view !== "desktop") ? true : false;
        if (m) {
            carouselStyle.padding = `${mobile_padding_y}px ${mobile_padding_x}px`;
            carouselStyle.backgroundPositionX = mobile_bg_horizontal_align;
            carouselStyle.backgroundPositionY = mobile_bg_vertical_align;
            background_position = mobile_bg_horizontal_align + " " + mobile_bg_vertical_align;
            carouselStyle.maxWidth = (mobile_width) ? mobile_width + "px" : "100%";
            switch (mobile_align) {
                case "center":
                    _align = "0 auto"
                    break;
                case "right":
                    _align = "0 0 0 auto"
                    break
                default:
                    _align = "0 0 0 0"
            }
            carouselStyle.margin = _align;
        }


        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={carouselStyle}>
                    <Carousel
                        image_radius={image_radius}
                        auto={auto} timeout={timeout}
                        background_position={background_position}
                        background_size={(m) ? mobile_background_size : background_size}
                        height={(m) ? mobile_height : height}
                        button_type={button_type}
                        animation={animation}
                        images={images}
                        content_header_style={(m) ? mobile_content_header_style : content_header_style}
                        content_paragraph_style={content_paragraph_style}
                        content_button_style={content_button_style}
                        content_padding_x={content_padding_x}
                        content_padding_y={content_padding_y}
                        content_align={content_align}
                        content_justify={content_justify}
                        content_text_align={content_text_align}
                        image_opacity={image_opacity}
                        contained={contained}
                        content_max_width={content_max_width}
                    />

                </div>
            </div>
        );
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* BACKGROUND PADDING */}
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    const drawMobile = () => {

        return (
            <>
                <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                <PresetPicker value={mobile_content_header_style} onChange={(e) => setData({ ...data, "mobile_content_header_style": e })} />
                <div className="shim" /> <div className="shim" />

                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    {/* WIDTH / HEIGHT */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH / HEIGHT</Divider>
                    <div className="float-flex">
                        <div></div>
                        <Space size={0}>
                            <BMInput width={"45px"} value={mobile_width} onChange={(_v) => setData({ ...data, "mobile_width": _v })} number min={0} max={1920} prefix={<Tooltip title={tt_ic_width}>WIDTH</Tooltip>} />
                            <BMInput width={"45px"} value={mobile_height} onChange={(_v) => setData({ ...data, "mobile_height": _v })} number min={0} max={1000} prefix="HEIGHT" />
                        </Space>
                    </div>
                    <div className="shim" /> <div className="shim" />

                    {/* ALIGN */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / PADDING</Divider>
                    <div className="float-flex">
                        <Space>
                            <div><Tooltip title={tt_ic_align}><PicLeftOutlined onClick={() => setData({ ...data, "mobile_align": "left" })} style={{ "color": (mobile_align === "left") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                            <div><Tooltip title={tt_ic_align}><PicCenterOutlined onClick={() => setData({ ...data, "mobile_align": "center" })} style={{ "color": (mobile_align === "center") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                            <div><Tooltip title={tt_ic_align}><PicRightOutlined onClick={() => setData({ ...data, "mobile_align": "right" })} style={{ "color": (mobile_align === "right") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        </Space>
                        <Space>
                            <BMInput value={mobile_padding_x} onChange={(_v) => setData({ ...data, "mobile_padding_x": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_ic_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput value={mobile_padding_y} onChange={(_v) => setData({ ...data, "mobile_padding_y": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_ic_padding_y} ><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        </Space>
                    </div>
                    <div className="shim" /> <div className="shim" />

                    {/* BACKGROUND ALIGN */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE DISPLAY</Divider>
                    <div className="float-flex">
                        <Space>
                            <PositionAlign value={mobile_bg_horizontal_align} onChange={(e) => setData({ ...data, "mobile_bg_horizontal_align": e })} />
                            <PositionAlign value={mobile_bg_vertical_align} type="vertical" onChange={(e) => setData({ ...data, "mobile_bg_vertical_align": e })} />
                        </Space>
                        <div>&nbsp;&nbsp;&nbsp;</div>

                        <Select value={mobile_background_size} onChange={(e) => setData({ ...data, "mobile_background_size": e })} size="small" style={{ "width": "100%" }} >
                            <Select.Option key="cover" value="cover"><small>Cover</small></Select.Option>
                            <Select.Option key="contain" value="contain"><small>Contain</small></Select.Option>
                            <Select.Option key="none" value="none"><small>Initial</small></Select.Option>
                        </Select>

                    </div>
                    <div className="shim" /> <div className="shim" /><div className="shim" />

                </Spin>
            </>
        )

    }

    const drawDesktop = () => {
        return (
            <>
                {/* IMAGES */}
                <Images container={container} data={data} setData={setData} images={images} />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE OPACITY</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "100%" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "image_opacity": _v })}
                        value={image_opacity}
                    />
                </div>

                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX CONTENT WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "content_max_width": _v })}
                        disabled={!contained}
                        value={content_max_width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "contained": e.target.checked })} checked={contained}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                <PresetPicker value={content_header_style} onChange={(e) => setData({ ...data, "content_header_style": e })} />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PARAGRAPH PRESET</Divider>
                <PresetPicker value={content_paragraph_style} onChange={(e) => setData({ ...data, "content_paragraph_style": e })} />
                <div className="shim" /> <div className="shim" />


                {/* BUTTONS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CONTENT BUTTON STYLE</Divider>
                <ButtonPicker value={content_button_style} onChange={(e) => setData({ ...data, "content_button_style": e })} />
                <div className="shim" /> <div className="shim" />

                {/* CONTENT ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CONTENT DISPLAY / TEXT ALIGN</Divider>
                <div className="float-flex">
                    <Space>
                        <PositionAlign value={content_align} onChange={(e) => {
                            if (e === "left") { e = "start" }
                            if (e === "right") { e = "end" }
                            setData({ ...data, "content_align": e })
                        }} />
                        <PositionAlign value={content_justify} type="vertical" onChange={(e) => {
                            if (e === "top") { e = "start" }
                            if (e === "bottom") { e = "end" }
                            setData({ ...data, "content_justify": e })
                        }} />
                    </Space>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Select value={content_text_align} onChange={(e) => setData({ ...data, "content_text_align": e })} size="small" style={{ "width": "100%" }} >
                        <Select.Option key="left" value="left"><small>Left</small></Select.Option>
                        <Select.Option key="right" value="right"><small>Right</small></Select.Option>
                        <Select.Option key="center" value="center"><small>Center</small></Select.Option>
                    </Select>
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CONTENT PADDING</Divider>

                <Space>
                    <BMInput value={content_padding_x} onChange={(_v) => setData({ ...data, "content_padding_x": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_ic_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput value={content_padding_y} onChange={(_v) => setData({ ...data, "content_padding_y": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_ic_padding_y} ><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                </Space>

                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* BUTTONS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">NEXT / PREV BUTTONS</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE DISPLAY</Divider>
                <div className="float-flex">
                    <Space>
                        <PositionAlign value={bg_horizontal_align} onChange={(e) => setData({ ...data, "bg_horizontal_align": e })} />
                        <PositionAlign value={bg_vertical_align} type="vertical" onChange={(e) => setData({ ...data, "bg_vertical_align": e })} />
                    </Space>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Tooltip title={tt_ic_display}>
                        <Select value={background_size} onChange={(e) => setData({ ...data, "background_size": e })} size="small" style={{ "width": "100%" }} >
                            <Select.Option key="cover" value="cover"><small>Cover</small></Select.Option>
                            <Select.Option key="contain" value="contain"><small>Contain</small></Select.Option>
                            <Select.Option key="none" value="none"><small>Initial</small></Select.Option>
                        </Select>
                    </Tooltip>
                </div>
                <div className="shim" /> <div className="shim" /><div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <div><Tooltip title={tt_ic_align}><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip title={tt_ic_align}><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip title={tt_ic_align}><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                    </Space>
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_ic_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={500} prefix={<Tooltip placement="left" title={tt_ic_padding_y} ><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH / HEIGHT / BORDER RADIUS</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space size={0}>
                        <BMInput width={"45px"} value={width} onChange={(_v) => setData({ ...data, "width": _v })} number min={0} max={1920} prefix={<Tooltip title={tt_ic_width}>WIDTH</Tooltip>} />
                        <BMInput width={"45px"} value={height} onChange={(_v) => setData({ ...data, "height": _v })} number min={0} max={1000} prefix="HEIGHT" />
                        <BMInput width={"45px"} value={image_radius} onChange={(e) => setData({ ...data, "image_radius": e })} number min={0} max={1000} prefix="RADIUS" />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* ANIMATION */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ANIMATION</Divider>
                <Select value={animation} onChange={(e) => setData({ ...data, "animation": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"fade"} value={"fade"}><small>Fade</small></Select.Option>
                    <Select.Option key={"scroll"} value={"scroll"}><small>Scroll</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                {/* WIDTH / HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TIMING</Divider>
                <div className="float-flex">
                    <div>
                        <Checkbox checked={auto} onChange={(e) => setData({ ...data, "auto": e.target.checked })}><Tooltip title={tt_ic_animate}><small>Auto Animate?</small></Tooltip></Checkbox>
                    </div>
                    <Space>
                        <BMInput value={timeout} onChange={(_v) => setData({ ...data, "timeout": _v })} number min={1} max={20} prefix="SECONDS" />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}